import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { Header as BaseHeader } from '../../../../../BaseComponents';
const ExchangeRefundHeader = ({ className, title, breadcrumbs, isLoading, onClose, onGoBackward }) => {
    const { ExchangeRefundHeader: theme } = useTheme('Entities').Order;
    return (React.createElement(BaseHeader, { className: cn(theme.root, className, {
            [theme.loading]: isLoading
        }), classes: {
            inner: theme.wrapper,
            leftSlot: theme.title,
            closeWrapper: theme.close,
            centerSlot: theme.breadcrumbs
        }, left: title, center: breadcrumbs, equalSlotsBasis: false, showEmptySlots: false, onClose: onClose, onGoBackward: onGoBackward }));
};
export default ExchangeRefundHeader;
